import { useContext } from 'react';
import { useAutomationRulesViewContext } from './use-automation-rules-view-context';
import { AutomationRulesContext } from '../context';
import { FilterEditorContext } from '../../../../components/filter-editor/context';
import { AutomationRulesSteps, useTrackAutomationRulesWorkflow } from './use-track-automation-rules-workflow';
import { EventSourceStrings } from '../../../../tracking/tracking-constants';
import { useModalRuleProcessor } from '../ai-rule-creator/hooks/use-modal-rule-processor';
import { EXECUTOR_SLOT } from '../../../../components/shippy-assistant/llm-action-registry/types';
import { AUTOMATION_RULES_CREATE_ACTION_ID } from '../../../../components/shippy-assistant/llm-action-registry/action-definitions';
import { useLLMActionBinding } from '../../../../components/shippy-assistant/hooks/use-llm-action-binding';

/**
 * Binds the automation-rules-create action to the registry.
 * Defers binding until page data is hydrated:
 * - Filter fetch must complete (getNewTemporaryFilter mutates filterSets, fetch replaces it)
 * - Rule action types must be loaded (drawer needs them to render action dropdowns)
 * Must be called inside FilterEditorContextProvider and AutomationRulesContext.
 */

export const useAutomationRulesLLMBinding = () => {
  useAutomationRulesViewContext();

  const { processGeneratedRule } = useModalRuleProcessor();
  const { isLoadingFilters } = useContext(FilterEditorContext);
  const { selectedRule, ruleActionTypes } = useContext(AutomationRulesContext);
  const trackStart = useTrackAutomationRulesWorkflow(AutomationRulesSteps.START);

  const isReady = !isLoadingFilters && ruleActionTypes?.length > 0;

  useLLMActionBinding(
    isReady ? AUTOMATION_RULES_CREATE_ACTION_ID : null,
    (ruleData) => {
      trackStart({
        source: EventSourceStrings.SHIPPY_ASSISTANT,
        isAiGenerated: true,
      });

      const existingRuleId = selectedRule?.automationRuleId ?? null;
      processGeneratedRule(ruleData, existingRuleId);

      return { success: true };
    },
    { slot: EXECUTOR_SLOT },
  );
};
